module.exports = __webpack_public_path__ + "static/img/questionDSel.6840fdc9.png";